// styles
import '@/styles/components/loaders/page-loader.css'

export default function PageLoader() {
  return (
    <main className="app-shell p-24 min-h-screen w-full bg-center bg-no-repeat flex flex-col align-center justify-center text-center">
      <div className="flex flex-col m-auto items-center justify-center gap-2">
        <div className="loader-logo mb-8 flex flex-col items-center">
          <img src="/images/logos/logo-nina.svg" alt="Mãe Nutrida" className="h-16 w-16" />
          <div className="flex flex-col leading-tight mt-3 text-center">
            <span className="text-2xl font-bold text-coentro">mãe nutrida</span>
            <span className="text-xs text-muted-foreground">Materno-infantil</span>
          </div>
        </div>

        <div className="loader">
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
        <span className="text-sm font-semibold mt-6 text-muted-foreground tracking-wide">Carregando ...</span>
      </div>
    </main>
  )
}
